import * as plotlyEs from 'plotly.js/lib/locales/es';
import * as plotlyFr from 'plotly.js/lib/locales/fr';
import * as plotlyPt from 'plotly.js/lib/locales/pt-br';
import * as plotlyRu from 'plotly.js/lib/locales/ru';

export const plotlyLocales = {
  es: plotlyEs,
  fr: plotlyFr,
  'pt-br': plotlyPt,
  ru: plotlyRu,
};
